
<app-breadcrumbs title="Contact Management" [breadcrumbItems]="breadCrumbItems"></app-breadcrumbs>

<app-contact-list ></app-contact-list>
